export function isMoreThan(
  data?: number,
  compareNumber?: number,
): data is number {
  return typeof data === 'number' && data > (compareNumber ?? 0);
}

export function isLessThan(
  data?: number,
  compareNumber?: number,
): data is number {
  return typeof data === 'number' && data < (compareNumber ?? 0);
}

export function randomNumber() {
  const randomBuffer = new Uint32Array(1);
  const randomValue = crypto.getRandomValues(randomBuffer);
  const result = randomValue[0] / 2 ** 32;

  return result;
}
